import { describeError } from "../../../common/utils/error_message";
export const DRAFT_ANSWERS_KEY = "draftAnswers";
const MAX_HOURS_TO_STORE = 12;

export const saveDraftAnswer = (questionId, answerText) => {
	try {
		const storedAnswers = JSON.parse(localStorage.getItem(DRAFT_ANSWERS_KEY) || "{}");

		storedAnswers[questionId] = {
			text: answerText,
			timestamp: new Date().toISOString(),
		};

		localStorage.setItem(DRAFT_ANSWERS_KEY, JSON.stringify(storedAnswers));
	} catch (error) {
		console.error("Error saving draft answer:", describeError(error));
	}
};

export const getDraftAnswer = questionId => {
	try {
		const storedAnswers = JSON.parse(localStorage.getItem(DRAFT_ANSWERS_KEY) || "{}");

		if (!storedAnswers[questionId]) return null;

		const savedDate = new Date(storedAnswers[questionId].timestamp);
		const currentDate = new Date();
		const hoursDiff = (currentDate - savedDate) / (1000 * 60 * 60);

		if (hoursDiff > MAX_HOURS_TO_STORE) {
			deleteDraftAnswer(questionId);
			return null;
		}

		return storedAnswers[questionId].text;
	} catch (error) {
		console.error("Error getting draft answer:", describeError(error));
		return null;
	}
};

export const deleteDraftAnswer = questionId => {
	try {
		const storedAnswers = JSON.parse(localStorage.getItem(DRAFT_ANSWERS_KEY) || "{}");
		delete storedAnswers[questionId];
		localStorage.setItem(DRAFT_ANSWERS_KEY, JSON.stringify(storedAnswers));
	} catch (error) {
		console.error("Error deleting draft answer:", describeError(error));
	}
};

export const cleanupDraftAnswers = questionsList => {
	try {
		const storedAnswers = JSON.parse(localStorage.getItem(DRAFT_ANSWERS_KEY) || "{}");
		let hasChanges = false;

		const updatedAnswers = { ...storedAnswers };

		Object.keys(storedAnswers).forEach(questionId => {
			const savedDate = new Date(storedAnswers[questionId].timestamp);
			const currentDate = new Date();
			const hoursDiff = (currentDate - savedDate) / (1000 * 60 * 60);

			if (hoursDiff > MAX_HOURS_TO_STORE) {
				delete updatedAnswers[questionId];
				hasChanges = true;
				return;
			}

			const question = questionsList.find(q => q._id === questionId);
			if (question && question.question_status === "answered") {
				delete updatedAnswers[questionId];
				hasChanges = true;
			}
		});

		if (hasChanges) {
			localStorage.setItem(DRAFT_ANSWERS_KEY, JSON.stringify(updatedAnswers));
		}
	} catch (error) {
		console.error("Error cleaning up draft answers:", describeError(error));
	}
};
